export default "__VITE_ASSET__OXk1HFi5__"